export const interactionProgress = (currentItemNo, totalItems) => {
    return Math.round(currentItemNo / (totalItems - 1) * 100)
}